module.exports = __webpack_public_path__ + "static/media/white_farma.a02af75f.svg";